export default "__VITE_ASSET__CpVGklWk__"